import {
    GET_TOP_100_SITEMAP_CITIES_BY_STATE_CODE,
    GetSitemapCitiesByStateCodeType,
    GET_SITEMAP_CITIES_BY_COUNTRY,
    GetSitemapCitiesByCountryType,
    GET_SITEMAP_STATES_BY_COUNTRY,
    GetSitemapStatesByCountryType,
    GET_SITEMAP_COUNTRIES_BY_CONTINENT,
    GetSitemapCountriesByContinentType,
    SELECT_SITEMAP_CONTINENT,
    SelectContinentActionType,
    SELECT_SITEMAP_COUNTRY,
    SelectCountryActionType,
    SELECT_SITEMAP_STATE,
    SelectStateActionType
 } from '../actions/sitemapAction';

 import { SitemapCityByCountryType, StatesByCountryType, CountriesByContinentType } from '../../components/sitemap/common/types';

const getStateCities = (cities: SitemapCityByCountryType[] = []): SitemapCityByCountryType[] => {
    if(cities?.length) {
        const sortedstateCities = cities?.sort((cityA, cityB) => {
            const keyA = cityA?.CityName;
            const keyB = cityB?.CityName;
            if (keyA < keyB){
                return -1;  
            }
            if (keyA > keyB) {
                return 1;
            } 
            return 0;         
        });
        return sortedstateCities;
    }
    return [];
};

interface SitemapLocationsState {
    continentName?: string;
    countryName?: string;
    countryIso3?: string;
    stateName?: string;
    stateCode?: string;
    citiesList?: SitemapCityByCountryType[]
    statesList?: StatesByCountryType[];
    countriesByContinentList?: CountriesByContinentType[];
    continentsList?: [];
    continentRoute?: string,
    countryRoute?: string,
    stateRoute?: string;
    isLoadingCountriesByContinentList?: boolean;
    isLoadingCitiesList?: boolean;
    isLoadingStatesList?: boolean;
    lastErrorCountriesByContinent?: any;
    lastErrorCitiesByState?: any;
    lastErrorCitiesByCountry?: any;
    lastErrorStatesByCountry?: any;
}
const initialState: SitemapLocationsState = {
    isLoadingCitiesList: false,
    isLoadingCountriesByContinentList: false,
    isLoadingStatesList: false,
    statesList: [],
    countriesByContinentList: [],
    continentsList: [],
    citiesList: []
};

type SitemapLocationsActionType = | GetSitemapCitiesByStateCodeType | 
    GetSitemapCitiesByCountryType |
    GetSitemapStatesByCountryType | 
    GetSitemapCountriesByContinentType | 
    SelectContinentActionType |
    SelectCountryActionType |
    SelectStateActionType;

export function sitemapLocations(state = initialState, action: SitemapLocationsActionType): SitemapLocationsState
{
    switch (action.type)
    {
        case GET_SITEMAP_COUNTRIES_BY_CONTINENT.pending:
        {
            return {
                ...state,
                isLoadingCountriesByContinentList: true,
                countriesByContinentList: [],
                lastErrorCountriesByContinent: undefined
            };
        }
        case GET_SITEMAP_COUNTRIES_BY_CONTINENT.fulfilled:
        {
            return {
                ...state,
                isLoadingCountriesByContinentList: false,
                countriesByContinentList: action.payload
            };
        }
        case GET_SITEMAP_COUNTRIES_BY_CONTINENT.rejected:
        {
            return {
                ...state,
                isLoadingCountriesByContinentList: false,
                lastErrorCountriesByContinent: action.payload
            };
        }
        case GET_SITEMAP_CITIES_BY_COUNTRY.pending:
        {
            return {
                ...state,
                isLoadingCitiesList: true,
                citiesList: [],
                lastErrorCitiesByCountry: undefined
            };
        }
        case GET_SITEMAP_CITIES_BY_COUNTRY.fulfilled:
        {
            return {
                ...state,
                isLoadingCitiesList: false,
                citiesList: action.payload
            };
        }
        case GET_SITEMAP_CITIES_BY_COUNTRY.rejected:
        {
            return {
                ...state,
                isLoadingCitiesList: false,
                lastErrorCitiesByCountry: action.payload
            };
        }
        case GET_TOP_100_SITEMAP_CITIES_BY_STATE_CODE.pending:
        {
            return {
                ...state,
                isLoadingCitiesList: true,
                citiesList: [],
                lastErrorCitiesByState: undefined
            };
        }
        case GET_TOP_100_SITEMAP_CITIES_BY_STATE_CODE.fulfilled:
        {
            const stateCities = getStateCities(action?.payload);
            return {
                ...state,
                isLoadingCitiesList: false,
                citiesList: stateCities
            };
        }
        case GET_TOP_100_SITEMAP_CITIES_BY_STATE_CODE.rejected:
        {
            return {
                ...state,
                isLoadingCitiesList: false,
                lastErrorCitiesByState: action.payload
            };
        }
        case GET_SITEMAP_STATES_BY_COUNTRY.pending:
        {
            return {
                ...state,
                isLoadingStatesList: true,
                statesList: [],
                lastErrorStatesByCountry: undefined
            };
        }
        case GET_SITEMAP_STATES_BY_COUNTRY.fulfilled:
        {
            return {
                ...state,
                isLoadingStatesList: false,
                statesList: action.payload
            };
        }
        case GET_SITEMAP_STATES_BY_COUNTRY.rejected:
        {
            return {
                ...state,
                isLoadingStatesList: false,
                lastErrorStatesByCountry: action.payload
            };
        }
        case SELECT_SITEMAP_CONTINENT:
        case SELECT_SITEMAP_COUNTRY:
        case SELECT_SITEMAP_STATE:
        {
            return {
                ...state,
                ...action.payload
            };
        }
    }

    return state;
}